import React from "react"

import {
    Box,
    Grid,
    Pagination,
    Typography,
} from "@mui/material"
import {
    Timeline,
    TimelineConnector,
    TimelineContent,
    TimelineDot,
    TimelineItem,
    timelineItemClasses,
    TimelineSeparator,
} from "@mui/lab"

import { Trans } from "@lingui/macro"

import Icon from "@mdi/react"

import {
    Action,
    ActionUtils,
    PaginatedResponse,
} from "models"

interface HistoryProps {
    data: PaginatedResponse<Action> | null
    handlePaginationCallback: (pageId: number) => void
}
interface HistoryState {
    pageId: number
}
export class History extends React.Component<HistoryProps, HistoryState> {
    constructor(props: HistoryProps) {
        super(props)
        this.state = {
            pageId: this.props.data ? this.props.data.pagination.currentPage : 0,
        }
    }

    private handlePagination = (event: React.ChangeEvent<unknown>, value: number) => {
        this.setState(() => ({
            pageId: value - 1
        }), () => (this.props.handlePaginationCallback(value)))
    }


    render() {
        return (
            <div>
                {(this.props.data?.items.length ?? 0) === 0 &&
                    <Typography mt={5} textAlign="center">
                        <Trans id="actions.no-actions">
                            Nessuna azione trovata
                        </Trans>
                    </Typography>
                }
                {this.props.data && (this.props.data.items.length ?? 0) !== 0 &&
                    <Grid container>
                        <Grid container item xs={12} sx={{ mt: 3 }} justifyContent="center">
                            <Pagination showFirstButton showLastButton page={this.state.pageId + 1} onChange={this.handlePagination} />
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={12} sx={{ mt: 2, height: "50vh", mb: 2 }} overflow="auto">
                                    <Timeline
                                        sx={{
                                            [`& .${timelineItemClasses.root}:before`]: {
                                                flex: 0,
                                                padding: 0,
                                            },
                                        }}
                                    >
                                        {
                                            (this.props.data.items.map((item: Action) => (
                                                <TimelineItem key={item.id}>
                                                    <TimelineSeparator>
                                                        <TimelineDot>
                                                            <Icon path={ActionUtils.renderIcon(item)} />
                                                        </TimelineDot>
                                                        <TimelineConnector />
                                                    </TimelineSeparator>
                                                    <TimelineContent>
                                                        <Typography sx={{ fontSize: 14, fontWeight: "bold", }}>
                                                            <Trans id={"history.action-name"}>
                                                                Nome azione: {item.name}
                                                            </Trans>
                                                        </Typography>
                                                        <Box sx={{ bgcolor: "#e6ecff" }} mt={2} p={2}>
                                                            <Typography sx={{ fontWeight: "bold", fontSize: 13 }} display={"inline-block"}>
                                                                <Trans id={"history.action-status"}>
                                                                    Stato dell'azione:
                                                                </Trans>
                                                            </Typography>
                                                            {" "}
                                                            <Typography sx={{ fontSize: 13 }} display={"inline-block"}>
                                                                <Trans id={`enums.action-status.${item.status}`}>

                                                                </Trans>
                                                            </Typography>
                                                            <br />
                                                            {
                                                                item.workflow &&
                                                                <>
                                                                    <Typography sx={{ fontWeight: "bold", fontSize: 13 }} display={"inline-block"}>
                                                                        <Trans id={"history.action-workflow"}>
                                                                            Workflow di riferimento:
                                                                        </Trans>
                                                                    </Typography>
                                                                    {" "}
                                                                    <Typography sx={{ fontSize: 13 }} display={"inline-block"}>
                                                                        {item.workflow.name}
                                                                    </Typography>
                                                                </>
                                                            }
                                                            <br />
                                                            <Typography sx={{ fontWeight: "bold", fontSize: 13 }} display={"inline-block"}>
                                                                Note:
                                                            </Typography>
                                                            {" "}
                                                            <Typography sx={{ fontSize: 13 }} display={"inline-block"}>
                                                                {item.content.blocks ? item.content.blocks.map(block => block.text).join("\n") : ""}
                                                            </Typography>
                                                        </Box>
                                                    </TimelineContent>
                                                </TimelineItem>
                                            )))
                                        }
                                    </Timeline>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                }
            </div>
        )
    }
}
